import { Link } from "react-router-dom";

const FormConfirmation = () => {
  return (
    <section className="pt-8 pb-16 md:pt-16 md:pb-24 px-4">
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 md:pr-10 space-y-6 animate-slideInLeft">
          <h1 className="text-4xl md:text-5xl font-bold text-[#9B7B9F] mb-4">
            Vi har tagit emot din information
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Stort tack för ditt engagemang. Vi återkommer.
          </p>
          <Link 
            to="/"
            className="inline-flex items-center text-minnestig-purple hover:text-minnestig-teal text-lg"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
            Gå tillbaka till Demenshjältar
          </Link>
        </div>
        <div className="md:w-1/2 mt-12 md:mt-0 animate-slideInRight relative">
          <div className="relative overflow-hidden rounded-2xl shadow-xl">
            <div className="absolute inset-0 bg-gradient-to-r from-minnestig-purple/20 to-minnestig-purple/5 z-10 rounded-2xl"></div>
            <img 
              src="/images/header-family.png" 
              alt="Glada människor tillsammans" 
              className="w-full h-auto rounded-2xl object-cover"
              style={{ aspectRatio: "4/3" }}
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 h-24 w-24 bg-minnestig-lavender rounded-full -z-10"></div>
          <div className="absolute -top-6 -right-6 h-16 w-16 bg-minnestig-peach rounded-full -z-10"></div>
        </div>
      </div>
    </section>
  );
};

export default FormConfirmation; 